export default __webpack_public_path__ + "static/media/wtclogo.83db17f1.png";